import { getSpacing, SpacingName, ThemedFunctor } from '@doveit/lego';
import { css } from 'styled-components';

export const heroSectionPrimarySlot: ThemedFunctor = ({ theme }) => css`
  ${getSpacing.padding(theme, SpacingName.SMALL)};
  background: ${theme.palettes.neutrals.lightest};
  border: 1px solid ${theme.palettes.neutrals.light};
  border-radius: 6px;
  margin: 0 auto;
  box-shadow: -1.25rem 1.25rem 1.25rem rgba(0,0,0,0.05);
`;

export const uspSectionHeader: ThemedFunctor = ({ theme }) => css`
  background-color: ${theme.palettes.brand.primary};
  ${getSpacing.padding(theme, [SpacingName.BIG, 0])};
`;

export const whyChooseUsGridUnit: ThemedFunctor = () => css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`;

export const heroSectionPrimarySlotGridUnit: ThemedFunctor = () => css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`;
